import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'react-datepicker/dist/react-datepicker.css';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, } from '@cargomatic/ui';
import ErrorAlert from 'components/ui/ErrorAlert';
import { intentMap } from 'utils/formatters/stops';
import LocationDetails from './details/LocationDetails';
import { withTranslation } from 'react-i18next';
class EditStopLocationModal extends Component {
    constructor(props) {
        super(props);
        this.handleClose = () => {
            this.props.onClose();
        };
        this.handleFieldChange = (field) => (e) => this.setState({ [field]: e.target.value });
        this.handleWindowDateChange = (field) => (date) => this.setState({ [field]: date });
        this.handleAddContact = () => {
            const contacts = [
                ...this.state.contacts,
                {
                    name: '',
                    phone: '',
                },
            ];
            this.setState({ contacts });
        };
        this.handleLocationDetailsRemoveContact = (index) => {
            const contacts = [
                ...this.state.contacts.slice(0, index),
                ...this.state.contacts.slice(index + 1),
            ];
            this.setState({ contacts });
        };
        this.handleContactFieldChange = (index, formField, value) => {
            const contact = Object.assign({}, this.state.contacts[index]);
            contact[formField] = value;
            const contacts = [
                ...this.state.contacts.slice(0, index),
                contact,
                ...this.state.contacts.slice(index + 1),
            ];
            this.setState({ contacts });
        };
        this.handleLocationDetailsFieldChange = (address) => this.setState({ address });
        this.handleSave = () => {
            const intent = intentMap[this.state.action_type.toLowerCase()];
            const { action, empty } = intent;
            const stop = {
                action,
                empty,
                contacts: this.state.contacts,
                window_start: this.state.window_start,
                window_end: this.state.window_end,
                location: {
                    name: this.state.name,
                    address: this.state.address,
                },
                equipments: this.state.equipments,
            };
            const validationErrors = this.validate(stop.location);
            if (Object.keys(validationErrors).length === 0) {
                this.setState({
                    stopPending: true,
                }, () => this.props.onSave(stop));
            }
        };
        const stop = props.stop || {};
        const { action, empty } = stop;
        const prefix = empty ? '_empty' : '';
        const action_type = `${action}${prefix}`;
        this.state = {
            validationErrors: {},
            action_type,
            window_start: stop.window_start,
            window_end: stop.window_end,
            name: stop && stop.location ? stop.location.name : '',
            address: stop && stop.location ? stop.location.address : '',
            contacts: stop.contacts || [],
            stopPending: false,
            equipments: stop.equipments || [],
        };
    }
    validate(data) {
        const validationErrors = {};
        const { t } = this.props;
        if (!data.address) {
            validationErrors.address = t('SET_AN_ADDRESS');
        }
        if (!data.name) {
            validationErrors.name = t('SET_A_NAME');
        }
        this.setState({
            validationErrors,
        });
        return validationErrors;
    }
    renderLocationDetails() {
        let errors = {};
        const { validationErrors } = this.state;
        if (validationErrors.address) {
            errors = { address: validationErrors.address };
        }
        if (validationErrors.name) {
            errors = { name: validationErrors.name };
        }
        return (React.createElement(LocationDetails, { locationAddressId: "edit-stop-location-address", locationNameId: "edit-stop-location-name", action_type: this.state.action_type, name: this.state.name, address: this.state.address, window_start: this.state.window_start, window_end: this.state.window_end, contacts: this.state.contacts, sectionTitle: "", errors: errors, onAddContact: this.handleAddContact, onRemoveContact: this.handleLocationDetailsRemoveContact, onChange: this.handleFieldChange, onWindowDateChange: this.handleWindowDateChange, onAddressChange: this.handleLocationDetailsFieldChange, onContactFieldChange: this.handleContactFieldChange }));
    }
    renderValidationErrors() {
        const validationErrorKeys = Object.keys(this.state.validationErrors);
        if (validationErrorKeys.length === 0) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement("div", { className: "w-full" },
            React.createElement(ErrorAlert, { title: t('MISSING_FIELDS') },
                React.createElement("ul", null, validationErrorKeys.map((key) => (React.createElement("li", { key: key }, this.state.validationErrors[key])))))));
    }
    renderActions() {
        const { t } = this.props;
        return (React.createElement("div", { className: "actions-wrapper" },
            React.createElement("div", { className: "flex" }, this.renderValidationErrors()),
            React.createElement("div", { className: "flex justify-end" },
                React.createElement("div", { className: "button-group flex" },
                    React.createElement("button", { className: "block mr-2 button button-green", disabled: this.state.stopPending, onClick: this.handleSave },
                        this.state.stopPending && (React.createElement("i", { className: "fa fa-circle-o-notch fa-spin mr-2" })),
                        t('SAVE_STOP')),
                    React.createElement("button", { className: "block button secondary-action", onClick: this.handleClose }, t('CANCEL'))))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Dialog, { open: true, onOpenChange: this.handleClose },
            React.createElement(DialogContent, { className: "sm:max-w-[800px] max-h-[90vh] overflow-y-auto" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, t('LOCATION_DETAILS'))),
                this.renderLocationDetails(),
                React.createElement(DialogFooter, null, this.renderActions()))));
    }
}
EditStopLocationModal.propTypes = {
    stop: PropTypes.object,
};
EditStopLocationModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};
export default withTranslation()(EditStopLocationModal);
